var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"change-xzqh",style:({ zoom: _vm.screenIndexWidth < 1600 ? 0.8 : 1 }),attrs:{"id":"change-xzqh"}})
}
var staticRenderFns = []

export { render, staticRenderFns }